export default "__VITE_ASSET__a958f51b__"